import { useEffect, useState } from "react";
import { fetchNicheRollup } from "../../core/api/nicheRollupApi";

// The account's niche roll-up, loaded once each time the Audits page opens,
// separately from the Snapshots list, so a slow or failed roll-up never holds
// the list up. { status: "off" | "loading" | "ready" | "error", rollup, ms }.
export default function useNicheRollup(agencyId, enabled) {
  const [state, setState] = useState({ status: "loading", rollup: null, ms: null });

  useEffect(() => {
    if (!enabled || !agencyId) return undefined;
    let cancelled = false;
    const started = Date.now();
    setState({ status: "loading", rollup: null, ms: null });
    fetchNicheRollup(agencyId).then(
      rollup => { if (!cancelled) setState({ status: "ready", rollup, ms: Date.now() - started }); },
      error => {
        console.error("fetchNicheRollup", error);
        if (!cancelled) setState({ status: "error", rollup: null, ms: Date.now() - started });
      },
    );
    return () => { cancelled = true; };
  }, [agencyId, enabled]);

  return enabled && agencyId ? state : { status: "off", rollup: null, ms: null };
}
